export { CommonEventStatusId } from '../common/index.js'

export const enum BaseballEventStatusId {
  NotStarted = 1,
  StartDelayed = 6,
  DelayedByRain = 149,
  Interrupted = 2,
  Postponed = 5,
  Abandoned = 7,
  CalledGame = 150,
  Finished = 11,
  FinishedAwardedWin = 12,
  FinishedAfterExtraInning = 143,
  Cancelled = 3,
  CancelledDueRain = 151,
  ToFinish = 152,
  FirstInning = 49,
  BreakAfterFirstInning = 363,
  SecondInning = 50,
  BreakAfterSecondInning = 364,
  ThirdInning = 51,
  BreakAfterThirdInning = 365,
  FourthInning = 52,
  BreakAfterFourthInning = 366,
  FifthInning = 53,
  BreakAfterFifthInning = 367,
  SixthInning = 54,
  BreakAfterSixthInning = 368,
  SeventhInning = 55,
  BreakAfterSeventhInning = 369,
  EighthInning = 56,
  BreakAfterEighthInning = 370,
  NinthInning = 57,
  BreakAfterNinthInning = 371,
  TenthInning = 58,
  BreakAfterTenthInning = 372,
  EleventhInning = 59,
  BreakAfterEleventhInning = 373,
  TwelfthInning = 60,
  BreakAfterTwelfthInning = 374,
  ThirteenthInning = 61,
  BreakAfterThirteenthInning = 375,
  FourteenthInning = 62,
  BreakAfterFourteenthInning = 376,
  FifteenthInning = 63,
  BreakAfterFifteenthInning = 377,
  SixteenthInning = 64,
  BreakAfterSixteenthInning = 378,
  SeventeenthInning = 166,
  BreakAfterSeventeenthInning = 379,
  EighteenthInning = 167,
  BreakAfterEighteenthInning = 380,
  NineteenthInning = 168,
  BreakAfterNineteenthInning = 381,
  TwentiethInning = 169,
  BreakAfterTwentiethInning = 382,
  TwentyFirstInning = 170,
  BreakAfterTwentyFirstInning = 383,
  TwentySecondInning = 171,
  BreakAfterTwentySecondInning = 384,
  TwentyThirdInning = 172,
}
